import { render, staticRenderFns } from "./ProductionDashboard.vue?vue&type=template&id=5d4bc620&lang=pug&"
import script from "./ProductionDashboard.vue?vue&type=script&lang=ts&"
export * from "./ProductionDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionDashboard.vue?vue&type=style&index=0&id=5d4bc620&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports